/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Graph-Alt': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<defs><path pid="0" d="M6.442 15.09a1.5 1.5 0 011.5 1.5v6.91a1.5 1.5 0 01-3 0v-6.91a1.5 1.5 0 011.5-1.5zm7.027-2.704a1.5 1.5 0 011.5 1.5V23.5a1.5 1.5 0 01-3 0v-9.614a1.5 1.5 0 011.5-1.5zm7.11 4.816c.807 0 1.46.654 1.46 1.46v4.878A1.46 1.46 0 0120.58 25h-.08a1.46 1.46 0 01-1.46-1.46v-4.878c0-.806.655-1.46 1.46-1.46h.08zM11.718 3l9.013 7.727 3.444-3.487L26 9.083l-5.124 5.189-9.016-7.73-8.036 8.114L2 12.811 11.717 3z" id="svgicon_Graph-Alt_a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_Graph-Alt_b" _fill="#fff"><use xlink:href="#svgicon_Graph-Alt_a"/></mask><use _fill="#AFAFAF" fill-rule="nonzero" xlink:href="#svgicon_Graph-Alt_a"/><g mask="url(#svgicon_Graph-Alt_b)" _fill="#CFCFCF"><path pid="1" d="M0 0h28v28H0z"/></g></g>'
  }
})
